import { AsyncPipe, NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output, ViewContainerRef } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { Store } from '@ngrx/store';
import { NavigationComponent, SharedModule, UntilDestroy, untilDestroyed } from '@shared';
import { AuthActions, AuthInfo, selectAuthInfo } from '@shared/store';
import { AngularSvgIconModule } from 'angular-svg-icon';
import Cookies from 'js-cookie';
import { distinctUntilChanged } from 'rxjs';
import { LoaderService } from 'thkee-common';

@UntilDestroy()
@Component({
  selector: 'app-instructor-header',
  templateUrl: './instructor-header.component.html',
  styleUrls: ['./instructor-header.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    RouterLink,
    RouterLinkActive,
    AngularSvgIconModule,
    SharedModule,
    NgFor,
    NgIf,
    NgTemplateOutlet,
    NavigationComponent,
    AsyncPipe,
  ],
})
export class InstructorHeaderComponent implements OnInit {
  heading: any;
  isSidebar: boolean = false;
  @Input() fullSize: boolean = false;
  @Output() toggleSidebar: EventEmitter<boolean> = new EventEmitter();

  userAuthInfo$ = this.store.select(selectAuthInfo);
  userAuthInfo!: AuthInfo;
  isToggle$ = this.loaderService.response('instructor-course-mobile-toggle');

  constructor(public viewContainerRef: ViewContainerRef, private store: Store, private loaderService: LoaderService) {}

  ngOnInit(): void {
    this.isToggle$.subscribe((data) => {
      if (data === 'loading') {
        this.isSidebar = true;
      } else {
        this.isSidebar = false;
      }
    });
    this.store
      .select(selectAuthInfo)
      .pipe(distinctUntilChanged(), untilDestroyed(this))
      .subscribe((authInfo) => {
        this.userAuthInfo = authInfo;
      });
  }

  logout() {
    this.store.dispatch(AuthActions.logout());
  }

  switchToStudent() {
    const lang = localStorage.getItem('thk_lang') ?? Cookies.get('lang');
    if (lang === 'en-US') {
      window.location.replace('/en/student/dashboard');
    } else {
      window.location.replace('/student/dashboard');
    }
  }

  headerAction() {
    this.isSidebar = !this.isSidebar;
    this.toggleSidebar.emit(this.isSidebar);
  }

  get fullName(): string {
    return this.userAuthInfo.fullname ?? '';
  }

  get userEmail(): string {
    return this.userAuthInfo.email ?? '';
  }

  get photoUrl(): string {
    return this.userAuthInfo.photo_url ?? '';
  }

  get instructorId(): number {
    return this.userAuthInfo.instructor_id ?? 0;
  }
}
